import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    DownloadTearSheetParameter,
    DownloadTearSheetResultModel,
    getDownloadTearSheet,
} from "@tSurya/Services/DownloadTearSheetService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type DownloadTearSheetParameterParam = HasOnSuccess<BlobPart> & DownloadTearSheetParameter & HasOnError;

type HandlerType = CustomApiHandler<DownloadTearSheetParameterParam, BlobPart>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getDownloadTearSheet(props.apiParameter)) as unknown as BlobPart;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const blob = new Blob([props.apiResult], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${props.apiParameter.erpNumber}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);

        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const downloadTearSheet = createHandlerChainRunner(chain, "DownloadTearSheet");
export default downloadTearSheet;
